import styled from "styled-components";

export const ContainerOfModal = styled.div`
  background-color: #fff;
  width: 600px;
  border-radius: 1rem;
  padding: 1.5rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`

export const FormData = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  position: relative;
`

export const InputLabel = styled.label`
  font-weight: 700;
  color: #000;
`

export const InputData = styled.input`
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 40px;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const BottomDiv = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap:1.5rem;
  span{
    color:red;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 1rem;
`

export const ButtonDiv = styled.div`
  background-color: #0090D3;
  color: #fff;
  padding: .7rem 1.2rem;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  img{
    width: 1rem;
  }
  &.cancel{
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }
`